import PropTypes from "prop-types";
import React from "react";

const Revisit = ({showDesc, title}) => {
  return (
    <span className="Revisit">
      <span
        className="erg-margin-right-5 text-info"
        title={!showDesc ? title : ""}>
        <i className="fa fa-history" />
      </span>
      {showDesc ? <span className="icon-desc">{title}</span> : null}
    </span>
  );
};

Revisit.propTypes = {
  showDesc: PropTypes.bool,
  title: PropTypes.string,
};

Revisit.defaultProps = {
  title: "This is a Revisit",
};

export default Revisit;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/icons/Revisit.js
 **/